import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/partner/opportunity";

/**
 * 商机列表页接口
 * 商机列表页只调用本文件，阶段/客户/职员下拉走 commonApi
 */
export default {
    /** 查询商机列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 查询商机详情 */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id}}),
    /** 保存商机 */
    saveOpportunity: (data) => axios.post({url: `${PREFIX_URI}/saveOpportunity`, data}),
    /** 商机转客户 */
    convertToCustomer: (id) => axios.get({url: `${PREFIX_URI}/convertToCustomer`, data: {id}}),
    /** 查询跟进记录列表 */
    queryFollowList: (data) => axios.get({url: `${PREFIX_URI}/queryFollowList`, data}),
    /** 查询某个对象（商机或客户）的跟进动态 */
    queryFollowByPartner: (partnerId) => axios.get({url: `${PREFIX_URI}/queryFollowByPartner`, data: {partnerId}}),
    /** 保存跟进记录 */
    saveFollow: (data) => axios.post({url: `${PREFIX_URI}/saveFollow`, data}),
}
